import React from 'react';

const Table = ({ children, ...props }) => {
  return (
    <table className="border-collapse border border-gray-100 mt-4 w-full table-auto" {...props}>
      {children}
    </table>
  );
};

const Head = ({ children, ...props }) => {
  return (
    <thead className="bg-gray-100" {...props}>
      <tr>{children}</tr>
    </thead>
  );
};

const Th = ({ children, sortKey, onSort, sortBy, sortDirection, ...props }) => {
  if (!sortKey) {
    return (
      <th className="py-2 px-4 text-left whitespace-nowrap" {...props}>
        {children}
      </th>
    );
  }

  return (
    <th className="py-2 px-4 text-left whitespace-nowrap" {...props}>
      <button onClick={() => onSort(sortKey)} className="flex">
        {children} {sortKey === sortBy && (sortDirection === -1 ? '▼' : '▲')}
      </button>
    </th>
  );
};

const Row = ({ children, ...props }) => {
  return (
    <tr className="border-b border-gray-100 bg-white hover:bg-yellow-100 odd:bg-gray-50" {...props}>
      {children}
    </tr>
  );
};

const Td = ({ children, className, ...props }) => {
  return (
    <td
      className={`overflow-hidden truncate whitespace-nowrap w-60 py-2 px-4 ${className} `}
      style={{ maxWidth: '420px' }}
      {...props}
    >
      {children}
    </td>
  );
};

export default {
  Table,
  Head,
  Th,
  Row,
  Td,
};
